import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import type { TooltipProps } from 'antd';
import clsx from 'clsx';

// NOTE: antd puts `className` on the trigger child, so the overlay class must go
// through `overlayClassName` to land on the portal-rendered panel.
export const Tooltip = ({
  overlayClassName,
  children,
  ...props
}: TooltipProps) => (
  <>
    <AntTooltip
      {...props}
      overlayClassName={clsx('wk-tooltip', overlayClassName)}
    >
      <span className="wk-tooltip__trigger">{children}</span>
    </AntTooltip>
    <style jsx>{`
      .wk-tooltip__trigger {
        max-width: 100%;
      }
    `}</style>
  </>
);
